import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './Store';
import "./i18n"
import UniversalLoader from './Components/Loader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store} >
        <BrowserRouter>
            <Suspense fallback={<UniversalLoader />}>
                <App />
            </Suspense>
        </BrowserRouter>
    </Provider>
);

reportWebVitals();
